import axios from 'axios';

const API_BASE = 'https://canvasoft.com:8487/canvamanager';

export interface Usuario {
  id?: number;
  idGoogle: string;
  email: string;
  name: string;
  givenName?: string;
  familyName?: string;
  picture?: string;
  locale?: string;
  verifiedEmail?: boolean;
  suspended?: boolean;
  createdAt?: string;
  modifiedAt?: string;
}

export const authService = {
  async syncUser(googleUser: any): Promise<Usuario> {
    const response = await axios.post(`${API_BASE}/users/syncuser`, {
      idGoogle: googleUser.id,
      email: googleUser.email,
      name: googleUser.name,
      givenName: googleUser.given_name,
      familyName: googleUser.family_name,
      picture: googleUser.profilePicture,
      locale: 'es'
    });
    return response.data;
  }
};